






import {Vue, Component, Prop} from 'vue-property-decorator'
import { toI18n } from '@/utils/commonUtils';

@Component
export default class NcpTableBodyHead extends Vue {
	@Prop() private data!: string[]

	public toI18n(needToI18nStr: string): string {
		return toI18n(this.$t(needToI18nStr));
	}
}

